import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import "antd/dist/antd.css";
import Routes from "./config/routes/AppRoutes";
import "./App.css";
import { UserAction, DashboardAction, AuthAction } from "./store/actions";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Loader from "./components/loader";
import Cookies from "universal-cookie";

const cookies = new Cookies();

function App(props) {
  const [seconds, setSeconds] = useState(0);
  const history = useHistory();

  const dispatch = useDispatch();
  console.log("props_of_dir", props);
  useEffect(() => {
    const { getStoreName, subdomain } = props;
    getStoreName({ storeName: subdomain });
  }, []);

  useEffect(() => {
    document.getElementsByTagName("title")[0].innerHTML =
      props?.storeName?.rmx_company_asset?.store_name || "Main Frame";
  }, [props.storeName]);

  // Add this code in your React component
  // const IDLE_TIMEOUT = 300000; // Time in milliseconds (e.g., 1 minute)

  // useEffect(() => {
  //   let idleTimer;

  //   const resetIdleTimer = () => {
  //     clearTimeout(idleTimer);
  //     idleTimer = setTimeout(() => {
  //       // Perform logout action here
  //       // alert("doneeee")
  //       // lo
  //       // debugger
  //       // alert(jsoncookies.get("contractor_credentials"))
  //       cookies.remove('contractor_credentials', { domain })
  //       localStorage.clear()
  //       window.location.href = '/'

  //       // Call logout function or set a logout state
  //     }, IDLE_TIMEOUT);
  //   };

  //   const handleActivity = () => {
  //     resetIdleTimer();
  //   };

  //   window.addEventListener('mousemove', handleActivity);
  //   window.addEventListener('keydown', handleActivity);

  //   resetIdleTimer(); // Initial setup

  //   return () => {
  //     clearTimeout(idleTimer);
  //     window.removeEventListener('mousemove', handleActivity);
  //     window.removeEventListener('keydown', handleActivity);
  //   };
  // }, []);

  return (
    <>
      {props.storeLoader ? (
        <div
          style={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Loader />
        </div>
      ) : (
        <div
          className="App"
          id={props.modal?.modals.length !== 0 ? "filterModal" : undefined}
        >
          <Routes />
        </div>
      )}
    </>
  );
}
function mapDispatchToProps(dispatch) {
  return {
    checkAccount: (data) => dispatch(UserAction.checkAccountReq(data)),
    getStoreName: (data) => dispatch(AuthAction.getStoreUrlReq(data)),
  };
}
export default connect(
  (storeState) => ({
    app: storeState.App,
    modal: storeState?.Modal,
    user: storeState.AuthReducer.user,
    storeLoader: storeState.AuthReducer.storeLoader,
    storeName: storeState?.AuthReducer?.storeInfo,
  }),
  mapDispatchToProps
)(App);
